import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class HelpContainer extends Component {
    render() {
        const { t } = this.props;
        return (
            <div>
                <button
                    className="hidden"
                    data-target="#modalSuccessHelp"
                    data-toggle="modal"
                    id="btnSuccessHelp"
                    type="button">
                </button>
                <div className="modal fade" id="modalSuccessHelp" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>
                                    <Trans i18nKey='venta_linea.help.description'>
                                        0 <br /> 2
                                    </Trans>
                                </p>
                                <a href="tel:+8003000467">
                                    <button
                                        className="btn btn-default"
                                        // data-dismiss="modal"
                                        type="button">
                                        <Trans>venta_linea.help.btn_call</Trans>
                                    </button>
                                </a>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    type="button">
                                    {t('dashboard.room_payment.btn_modal_exit')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    translate('common'),
    withRouter
)(HelpContainer);



// WEBPACK FOOTER //
// ./src/store/HelpContainer.js